import Marquee from "react-fast-marquee";
import { ClientLogoCard } from "@/components/shared/ClientLogos";

export const ClientLogoMarquee = ({ logos }) => (
  <div data-testid="client-logo-marquee" className="py-2">
    <Marquee speed={34} gradient={false} pauseOnHover>
      {logos.map((logo) => (
        <div key={logo.name} className="w-40 mx-3">
          <ClientLogoCard logo={logo} />
        </div>
      ))}
    </Marquee>
  </div>
);
